import styles from "./TrustpilotBanner.module.scss";

type Props = {
  className?: string;
};

export const TrustpilotBanner = ({ className = "" }: Props) => {
  return (
    <div className={`${className} ${styles.trustpilotBannerWrapper} w-full`}>
      <div
        className="container flex content-center items-end mx-auto relative"
        style={{ width: "99%" }}
      >
        <div className={`${styles.contentBlock} flex align-end`}>
          <i className="material-icons" data-icon="star"></i>
          <div className="flex flex-col">
            <span className="text">TrustPilot</span>
            <span className="text !text-white">5 Star Service</span>
          </div>
        </div>
        <div className={`${styles.contentBlock} ${styles.centerBlock}`}>
          <a href="tel:01772-566400" className="flex">
            <i className="material-icons" data-icon="call"></i>
            <div className="flex flex-col">
              <span className="text">Prefer to talk?</span>
              <span className="text text-white">01772 566400</span>
            </div>
          </a>
        </div>
        <span> </span>
        <div className={`${styles.contentBlock} ${styles.financeBlock} !mr-0`}>
          <a href="/buy/number-plate-finance/" className="flex">
            <div className="flex flex-col">
              <span className="text">
                <i
                  className="material-icons float-left"
                  data-icon="restore"
                ></i>
                0% APR <br></br> Finance
              </span>
              <span className="text text-white">No Deposit</span>
            </div>
          </a>
        </div>
        <div className={`${styles.financeArrow} absolute`}></div>
      </div>
    </div>
  );
};
